import { createStore } from "./hooks.js";

/** Multi-select for bulk edits. Ctrl/Cmd+click toggles a task, Shift+click selects a range. */
export const selection = createStore<{ ids: string[]; anchor: string | null }>({ ids: [], anchor: null });

export const useSelection = () => selection.use();
export const clearSelection = () => selection.set({ ids: [], anchor: null });

export function toggleSelected(id: string): void {
  selection.set((s) => ({ ids: s.ids.includes(id) ? s.ids.filter((x) => x !== id) : [...s.ids, id], anchor: id }));
}

/** Selects every id between the anchor and `id` in `visibleOrder`. */
export function selectRange(id: string, visibleOrder: string[]): void {
  selection.set((s) => {
    const a = s.anchor ? visibleOrder.indexOf(s.anchor) : -1;
    const b = visibleOrder.indexOf(id);
    if (a < 0 || b < 0) return { ids: [...new Set([...s.ids, id])], anchor: id };
    const [from, to] = a < b ? [a, b] : [b, a];
    return { ids: [...new Set([...s.ids, ...visibleOrder.slice(from, to + 1)])], anchor: s.anchor };
  });
}

/** Ids of task rows currently rendered, in screen order (for Shift+click ranges). */
export function visibleTaskIds(): string[] {
  return Array.from(document.querySelectorAll<HTMLElement>("[data-task-id]")).map((el) => el.dataset.taskId!);
}
